import { useEffect } from 'react'
import { getCurrentUser } from '../../../selectors/user.selectors'
import { Loader } from 'semantic-ui-react'
import { useReselector } from '../../../utils/sharedHooks'
import styled from 'styled-components'
import { Button, GridRowColumn } from '../../../components/BaseComponents'
import { useNavigate } from 'react-router-dom'
import { useAnalyticsTrack, useAnalyticsView } from '../../Amplitude'
import SignupSuccessSurvey from '../../Signup/SignupSuccessSurvey'
import { FEATURE_FLAG_KEYS } from '../../OpenFeature'
import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { NewObSplashScreen } from './NewObSplashScreen'
import { H1GetStartedUpdatesObScreen } from './H1GetStartedUpdatesObScreen'

export const ContainerStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  margin-bottom: 32px;
`

const SetupLandingCard = () => {
  const currentUser = useReselector(getCurrentUser)
  const navigate = useNavigate()
  const pageView = useAnalyticsView()
  const showObSurvey = useBooleanFlagValue(
    FEATURE_FLAG_KEYS.showOnboardingSurveys,
    false
  )
  const track = useAnalyticsTrack()

  const shouldEnableH1GetStartedUpdates = useBooleanFlagValue(
    FEATURE_FLAG_KEYS.enableH1GetStartedUpdates,
    false
  )

  useEffect(() => {
    pageView('onboarding items landing')
  }, [pageView])

  if (!currentUser) {
    return <Loader active />
  }

  const handleContinueClick = () => {
    track('completed onboarding items landing page')

    navigate('/onboarding-v2?stage=connect&step=baa')
  }

  return (
    <ContainerStyle>
      {shouldEnableH1GetStartedUpdates ? (
        <H1GetStartedUpdatesObScreen />
      ) : (
        <NewObSplashScreen />
      )}
      {showObSurvey && <SignupSuccessSurvey />}
      <GridRowColumn
        style={{
          display: 'flex',
          justifyContent: 'right',
          paddingBottom: '2rem',
        }}
      >
        <Button variant="primary" size="medium" onClick={handleContinueClick}>
          Continue
        </Button>
      </GridRowColumn>
    </ContainerStyle>
  )
}

export default SetupLandingCard
